// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-footer[data-v-33b2e0ac]{justify-content:center}.auth_infos[data-v-33b2e0ac]{position:fixed;top:40%;left:30%;width:40%;z-index:3}", ""]);
// Exports
module.exports = exports;
